export { IsCouplesRightToMe } from "./IsCouplesRightToMe"
